export const enum SPECIAL_TERMS_FIELD {
	SPECIAL_TERMS = 'SpecialTerms'
}

export type SpecialTermsFieldType = {
	[SPECIAL_TERMS_FIELD.SPECIAL_TERMS]: string
}

export type SpecialTermsFieldReturnType = {
	specialTerms: string
}

export const initialSpecialTermsValues: SpecialTermsFieldType = {
	[SPECIAL_TERMS_FIELD.SPECIAL_TERMS]: ''
};

export const getFormattedSpecialTermsField = (formikValues): SpecialTermsFieldReturnType => ({
	specialTerms : formikValues?.[SPECIAL_TERMS_FIELD.SPECIAL_TERMS]
});

export const convertToSpecialTermsInitial = (data): SpecialTermsFieldType => ({
	[SPECIAL_TERMS_FIELD.SPECIAL_TERMS]: data?.specialTerms
});

export const getFormattedSpecialTermsData = (data): SpecialTermsFieldReturnType => ({
	specialTerms: data?.specialTerms
});
